import { render, staticRenderFns } from "./DiceHelpDialog.vue?vue&type=template&id=37a0169c&lang=pug&"
import script from "./DiceHelpDialog.vue?vue&type=script&lang=ts&"
export * from "./DiceHelpDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DiceHelpDialog.vue"
export default component.exports